var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const basePath = '/ApiEulas';
export const apiEulasDataProvider = context => {
    return {
        getOne: async ({ id }) => {
            const url = `${context.apiUrl}${basePath}('${id}')`;
            const data = __rest((await context.fetchJson(url, { credentials: 'include' })).json, []);
            return {
                data: Object.assign({ id }, data),
            };
        },
    };
};
//# sourceMappingURL=apiEulas.js.map